import React from 'react'
import Checkbox from '@mui/material/Checkbox'

const AdxCheckbox = ({ type, sx, checked, onChange, disabled = false, ...rest }) => {
  // props
  // 1. type: string
  // accepted value: 'fill'

  const disabledStyle = () => {
    return {
      color: 'gray-line.main',
      backgroundColor: 'transparent',
      p: '9px',
      height: '45px',
      width: '42px',
    }
  }
  return (
    <Checkbox
      disabled={disabled}
      checked={checked}
      onChange={onChange}
      disableRipple
      color="alternate"
      sx={{ '&.Mui-disabled': disabledStyle(), ...sx }}
      {...rest}
    />
  )
}

export default AdxCheckbox
